import { render, staticRenderFns } from "./PerformanceStatusItem.vue?vue&type=template&id=509b61f4&scoped=true&"
import script from "./PerformanceStatusItem.vue?vue&type=script&lang=ts&"
export * from "./PerformanceStatusItem.vue?vue&type=script&lang=ts&"
import style0 from "./PerformanceStatusItem.vue?vue&type=style&index=0&id=509b61f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509b61f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCheckbox,VIcon,VTooltip})
